<template>
    <v-container fluid pa-0>
         <!--v-toolbar v-if="destacados.length != 0" dense flat color="blue noborderradius" dark>
             <v-btn                
            flat
            @click.prevent="visible = !visible"
            ><v-icon left dark>view_headline</v-icon>
            </v-btn>
            Promociones Destacadas
        </v-toolbar>
        <v-layout v-if="visible">
            <v-flex x12 md4 v-for="promo in destacados" :key="promo.ItemNo+promo.ItemPromo+promo.MinQty" @click="openPromoDialog(promo)">
                <v-card>                    
                    <v-img
                    max-height="150"
                    :src="promo.ItemPromoPictureURL"
                    >
                        
                    </v-img>      
                    <v-card-title class="align-end fill-height font-weight-bold">
                        {{promo.PromoCode}} - {{promo.PromoQty}}
                    </v-card-title>                                     
                    <v-card-text>
                        Pidiendo {{Number(promo.MinQty)}} del producto {{promo.ItemNo}}
                    </v-card-text>                                  
                </v-card>
            </v-flex>            
        </v-layout-->
        <v-expansion-panel v-if="destacados.length != 0" >            
            <v-expansion-panel-content
                v-for="(item,i) in 1"
                :key="i">
                <template v-slot:header>
                <div>Promociones Destacadas</div>
            </template>
            <v-layout>
                <v-flex x12 md4 v-for="promo in destacados" :key="promo.ItemNo+promo.ItemPromo+promo.MinQty" @click="openPromoDialog(promo)">
                    <v-card>                    
                        <v-img
                        max-height="150"
                        :src="promo.ItemPromoPictureURL"
                        >                         
                        </v-img>      
                        <v-card-title class="align-end fill-height font-weight-bold">
                            {{promo.PromoCode}} - {{promo.PromoQty}}
                        </v-card-title>                                     
                        <v-card-text>
                            Pidiendo {{Number(promo.MinQty)}} del producto {{promo.ItemNo}}
                        </v-card-text>                                  
                    </v-card>
                </v-flex>
            </v-layout>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-container>
</template>
<script>
export default {
    name: 'promocionesDestacadas',
    data(){
        return{            
        }
    },
    methods:{
        imageLoadError (promo) {
            //console.log('Image failed to load');            
            var file = require('../assets/noimage.png');
            promo.ItemPromoPictureURL = file;                           
        }
    },
    watch:{        
        items: function (val){
            //Se hace un resumen de las principales promociones en la seleccion de articulos actual
            //La 3 primeras promocioes validas de 3 articulos
            /*this.destacados = [];            
            var res = this.items.filter(item => {
                return (item.promoCode !=  null);
            });            
            for(var i = 0; i<res.length; i++){                
                for (var j = 0; j < res[i].promos.length; j++){     
                    //if (res[i].promos[j].active){
                        this.destacados.push(res[i].promos[j]);
                        break;
                    //}
                }                
                if (this.destacados.length == 3) break;
            }
            //res[0].No = '123123';
            for(var i = 0; i<this.destacados.length; i++){
                if (this.destacados[i].ItemPromoPictureURL == ''){
                    this.imageLoadError(this.destacados[i]);
                }
            }*/
        }
    },
    computed:{
        items:{
            get(){
                return this.$store.state.items;
            },
            set(value){
                this.$store.commit('setItems',value);
            }
        },
        destacados:{
            get(){
                return this.$store.state.promosDestacadas;
            },
            set(value){
                this.$store.state.promosDestacadas = value;
            }
        },
        visible:{
            get(){
                return this.$store.state.promosDestacadasVisible;
            },
            set(value){
                this.$store.state.promosDestacadasVisible = value;
            }
        },
        dialog:{
            get(){
                return this.$store.state.dialogEditItem;
            },
            set(value){
                this.$store.state.dialogEditItem = value;
            }
        },
        dialogData:{
            get(){
                return this.$store.state.dialogData;
            },
            set(value){
                this.$store.state.dialogData = value;
            }
        },
        editedItems:{
            get(){
                return this.$store.state.editedItems;
            },
            set(value){
                this.$store.state.editedItems = value;
            }
        },
        editedIndex:{
            get(){
                return this.$store.state.editedIndex;
            },
            set(value){
                this.$store.state.editedIndex = value;
            }
        },
        sameNoItems:{
            get(){
                return this.$store.state.sameNoItems;
            },
            set(value){
                this.$store.state.sameNoItems = value;
            }
        },
        sameNoItemsBackup:{
            get(){
                return this.$store.state.sameNoItemsBackup;
            },
            set(value){
                this.$store.state.sameNoItemsBackup = value;
            }
        }
    }
}
</script>
<style scoped>

</style>